import React from 'react';
import { useDispatch } from 'react-redux';
import Axios from 'axios';

import { refreshToken as refreshTokenAction } from '@src/store/authentication/actions';

const useErrorHandler = () => {
  const dispatcher = useDispatch();

  return React.useCallback(
    (error: any) => {
      if (error.response) {
        switch (error.response.status) {
          case 401:
            dispatcher(refreshTokenAction());
            return { status: error.response.status, error };
          default:
            return { status: error.response.status, error };
        }
      } else if (error.request) {
        // console.error(error);
        return { status: -1, error };
      } else if (Axios.isCancel(error)) {
        // console.log(error.message);
        return { status: -2, error };
      } else {
        // console.error(error);
        return { status: 0, error };
      }
    },
    [dispatcher]
  );
};

export default useErrorHandler;
